import { useState } from 'react';
import ResourceActionModal from './ResourceActionModal';
import Modal from './Modal';

export default function ResourceList({ title, items, onDeactivate, onReactivate}) {
    const [selectedItem, setSelectedItem] = useState(null);
    const [showDeactivated, setShowDeactivated] = useState(false);

    const active = items.filter(item => item.is_active);
    const inactive = items.filter(item => !item.is_active)

    return (
        <div>
            <h5 className='font-medium mb-1'>{title}</h5>

            {inactive.length > 0 && (
                <label className='flex items-center gap-2 text-sm text-gray-600 mb-2 cursor-pointer'>
                    <input type='checkbox' checked={showDeactivated} onChange={(event) => setShowDeactivated(event.target.checked)} className='accent-docpgrPurple60 w-4 h-4' />
                    show deactivated {title.toLowerCase()}
                </label>
            )}

            {/* Active  */}
            {active.length > 0 ? (
                <ul className='space-y-1'>
                    {active.map(item => (
                        <li key={item.id} onClick={() => setSelectedItem(item)} className='flex justify-between items-center hover:bg-docpgrPurple10 rounded-md px-4 py-2'>
                            <span>{item.name}</span>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className='text-gray-500'>no active {title.toLowerCase()}</p>
            )}

            {/* Inactive  */}
            {showDeactivated && inactive.length > 0 && (
                    <ul className='mt-2 space-y-1 text-gray-500'>
                        {inactive.map(item => (
                            <li key={item.id} onClick={() => setSelectedItem(item)} className='flex justify-between items-center hover:bg-docpgrPurple10 rounded-md px-4 py-2'>
                                <span className='line-through'>{item.name}</span>
                            </li>
                        ))}
                    </ul>
            )}

            {selectedItem && (
                <Modal>
                    <ResourceActionModal title={title} item={selectedItem} onClose={() => setSelectedItem(null)} onDeactivate={onDeactivate} onReactivate={onReactivate} />
                </Modal>
            )}
        </div>
    )
}